// import $ from "jquery";
import {
    testDynData,
    getDynData,
    getDynDataOne,
    createGuid
}
from "./general_functions";
import { map__singlepoi } from "./map";
import language from "./translation";
import { getImageByContentId } from "./images";


export const getContactByEmail = (email, callback) => {


    if (client.contactApi) {
        $.get(client.contactApi + "/" + email).done(function(data) {
            // console.log(email, data);
            callback(data);
        });
    }

};

export const setContactRight = (model) => {

    // console.log(model);

    // console.log("modell", model);

    let phone = "",
        contact = "",
        email = "",
        name = "",
        address = "",
        title = "",
        dep = "",
        about = "",
        postaddress = "";
    // 
    // console.log("model", model);
    // 
    let phones = [];
    if (model.phone) {
        phones.push(`<a href="tel:${model.phone}">${model.phone}</a> `);
    }
    if (model.wiredPhone) {
        phones.push(`<a href="tel:${model.wiredPhone}">${model.wiredPhone}</a> `);
    }

    if (model.phone || model.wiredPhone) {
        //phone = `<p>${language("CONTACT_PHONE")}:<br/> <a href="tel:${model.phone}">${model.phone}</a></p>`;
        phone = `<div class="contact__card__icon__item"><span class="material-icons-outlined contact__card__icon">phone</span> ${phones.join(" / ")} </div>`;
    }
    if (model.contact) {
        if (model.contact.kontaktkort_tittel) {
            title = `<p>${model.contact.kontaktkort_tittel}</p>`;
        }
    }
    else if (model.title) {
        title = `<p>${model.title}</p>`;

    }
    if (model.email) {
        //email = `<p>${language("CONTACT_EMAIL")}:<br/> <a href="mailto:${model.email}" class="text-truncate">${model.email}</a></p>`;
        email = `<div class="xcol contact__card__icon__item"><span class="material-icons-outlined contact__card__icon">email</span><a href="mailto:${model.email}">${model.email}</a></div>`;
    }
    if (model.name) {
        name = `<h3 class="contact__card__name">${model.name}</h3>`;
    }
    if (model.pos) {
        let mapguid = createGuid();
        address = `
            <p>
                ${language("CONTACT_VISITTADDRESS")}:<br/> 
                ${model.pos.adressetekst}, 
                ${model.pos.postnummer} ${model.pos.poststed}<br/>
                <a href="#map" class='contact__openmap' 
                    data-lat="${model.pos.lat}" 
                    data-lon="${model.pos.lon}" 
                    data-openmap="${mapguid}"
                    data-popuptext="${model.pos.adressetekst} ${model.pos.postnummer} ${model.pos.poststed}" >Se kart</a>
                <div class='contact__place__map' data-mapid="${mapguid}" ></div>
            </p>`
    }
    else if (model.address) {
        if (model.address.kontaktkort_visitingaddress) {
            address = `<p class="contact__card__label">${language("CONTACT_VISITTADDRESS")}:<br/>${model.contact.kontaktkort_visitingaddress}</p>`;
        }
        else if (typeof model.address === "string") {
            address = `<p class="contact__card__label">${language("CONTACT_VISITTADDRESS")}:<br/> ${model.address}</p>`;
        }
    }
    if (model.postaddress) {
        // if(model.address !== model.postaddress){
        address += `<p class="contact__card__label">${language("CONTACT_POSTADDRESS")}:<br/>${model.postaddress}</p>`;
        // }
    }
    if (model.about) {
        about = `<p clas="contact__card__about">${model.about}</p>`;
    }


    return `
            <div class="contact__card">
            
                ${name}
                ${title}
                ${phone}
                ${email}
                ${address}
                ${about}
                
            </div>
       `;
}

export const setContactArticle = (model) => {

    let phone = "",
        contact = "",
        email = "",
        name = "",
        address = "",
        title = "",
        about = "",
        wiredPhone = "",
        dep = "";

    // console.log(model);

    let imageguid = createGuid();

    let imagespace = "col-1";

    let phones = [];
    if (model.phone) {
        phones.push(`<a href="tel:${model.phone}">${model.phone}</a> `);
    }
    if (model.wiredPhone) {
        phones.push(`<a href="tel:${model.wiredPhone}">${model.wiredPhone}</a> `);
    }

    if (model.phone || model.wiredPhone) {
        phone = `<div class="contact__card__icon__item"><span class="material-icons-outlined contact__card__icon">phone</span> ${phones.join(" / ")} </div>`;
    }
    if (model.title && model.department) {
        title = `<p>${model.title} ${model.department ? "- "+ model.department : ""}</p>`;
    }
    else if (model.department) {
        title = `<p>${language("CONTACT_DEPARTMENT")}: ${model.department}</p>`;
    }
    else if (model.title) {
        title = `<p>${model.title}</p>`;
    }
    if (model.email) {
        email = `<div class="contact__card__icon__item pl-md-4"><span class="material-icons-outlined contact__card__icon">email</span><a href="mailto:${model.email}">${model.email}</a></div>`;
    }
    if (model.name) {
        name = `<h3 class="contact__card__name">${model.name}</h3>`;
    }
    if (model.about) {
        about = `<p class="contact__card__about">${model.about}</p>`;
    }

    if (model.image) {
        getImageByContentId(model.image, (img) => {

            let cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill/" + img.url;

            $(`#image_${imageguid}`).html(`<img src="${cloudinaryUrl}" alt="Profilbile" />`);

        })

        imagespace = "contact__card__image";
    }


    // if(model.)


    return `
            <div class="contact__card contact__card--article">
                <div class="row ml-0 mr-0">
                    ${model.image ? `<div id="image_${imageguid}" class="${imagespace}"></div>` : ``}
                    <div>
                        ${name}
                        ${title} 
                    </div>
                </div>
                <div class="row contact__card__icon__row ml-0 mr-0">
                    ${phone}
                    ${email}
                </div>
                ${about}
            </div>
            <div class="col-1"></div>
            <!--/div>
            </div-->
       `;
}

export const setContactInfo = (data, wrapper = false) => {
    let cards = [];

    if (data[0].kontaktkort_personnavn.length < 1 && data[0].kontaktkort_tittel.length < 1) {
        // console.log("kontaktkort false - no phone, or Kontaktkort false - no title");
        return false;
    }

    $.each(data, function(nr, contact) {

        if (!contact.kontaktkort_personnavn) {
            contact.kontaktkort_personnavn = contact.kontaktkort_tittel;
            contact.kontaktkort_tittel = "";
        }


        let name = contact.kontaktkort_personnavn,
            title = contact.kontaktkort_tittel,
            phone = contact.kontaktkort_telefon,
            email = contact.kontaktkort_epost,
            address = contact.kontaktkort_visitingaddress,
            postaddress = contact.kontaktkort_postadresse,
            pos = contact.kontaktkort_posisjonsdata;


        console.log("contacts ssss", contact);

        cards.push(setContactRight({
            name: name,
            title: title,
            phone: phone,
            email: email,
            address: address,
            postaddress: postaddress,
            pos: pos
        }));


    });

    cards = cards.join("");

    $("body").on("click", ".contact__openmap", function(e) {
        e.preventDefault();

        let openmap = $(this).data("openmap");

        map__singlepoi(".contact__place__map[data-mapid=" + openmap + "]", {
            lat: $(this).data("lat"),
            lon: $(this).data("lon"),
            popuptext: $(this).data("popuptext"),
            zoom: 15
        })

    });


    if (wrapper == true) {


        return `
                <div class="article" id="unit__contact">
                
                    <div class="article__keyinfo">
                        <h2>${language("CONTACT_CONTACT")}</h2>
                        <div id="contact_cards">
                           ${cards}
                        </div>
                    </div>
                
                
                </div>`;
    }
    else {
        return `
                    <div class="article__keyinfo">
                        <h2>${language("CONTACT_CONTACT")}</h2>
                        <div id="contact_cards">
                           ${cards}
                        </div>
                    </div>
                `;
    }

}
export const ViewContactByAPI = (metaData, title = "", description = "", placement = "article") => {


    if (testDynData(metaData, "localId", "9c49f83a-bd49-425b-8fbb-6b211c038391")) { // Dynamisk mal kontaktkort.

        let mail = getDynDataOne(metaData, "9c49f83a-bd49-425b-8fbb-6b211c038391", "localId");
        let role = getDynDataOne(metaData, "4887e067-c9d5-4f35-b7a4-61222faf062b|9778c05a-d282-4cc2-8fed-30b2921dafde", "localId"); //.value; // 
        let desc = getDynDataOne(metaData, "cd822d62-0221-4c43-b59d-0755a34df95c", "localId"); //.value;

        // console.log(getDynData(metaData));

        // console.log("status", mail, role, desc, metaData);

        // console.log("metadata",metaData);

        if (mail) {

            // has mail. 
            mail = mail.value;

            // console.log("MAIL", mail)


            getContactByEmail(mail, function(data) {

                // console.log("getContactData",data);

                data = data[0];

                console.log("by-email", data);

                if (placement === "article") {


                    var contact = setContactArticle({
                        name: data.Name || false,
                        email: data.Email || false,
                        title: title,
                        phone: data.Mobile || false,
                        about: description,
                        department: data.Subdivision || false
                    });

                    $(`.article__content`).html(contact);
                }
                else if (placement === "right") {

                    // console.log("data", data);
                    // console.log("title", title, (title ? "true" : "false"));
                    // console.log("desc", description || desc.value);

                    // console.log("placement",title, role);


                    let contact = setContactRight({
                        name: data.Name || false,
                        email: data.Email || false,
                        title: title || role.value || false,
                        phone: data.Mobile || false,
                        about: description || desc.value,
                        department: data.Subdivision || false
                    });

                    // console.log("contact right ", contact);

                    // console.log("here? 3")
                    let html = `<div class="article__keyinfo">
                        <div class="contact--">
                           ${contact}
                        </div>
                    </div>`;

                    $("#unit__relations").append(html);

                }


            })

        }

        // console.log(mail);


    }
}
